import { useTranslate } from "ra-core";
import { Link } from "react-router";
import { QueryFallback } from "@/components/admin/query-fallback";

import {
  ActionTile,
  ActionTileName,
  ContactNameLink,
  OpenTaskDue,
} from "../palmtree/badges";
import { panelClass } from "../palmtree/shell";
import { useAandachtRows, useVandaagRows } from "../palmtree/useOpenActions";
import { DashboardNews } from "./DashboardNews";

export const Dashboard = () => {
  const translate = useTranslate();
  const { rows, queries } = useAandachtRows();
  const { preview, queries: vandaagQueries } = useVandaagRows();

  return (
    <div>
      <QueryFallback queries={[...queries, ...vandaagQueries]}>
        <div className="relative grid grid-cols-1 lg:grid-cols-[1fr_20rem] gap-5">
          <section className={panelClass}>
            <h2 className="font-heading px-6 py-6 text-xl font-extrabold tracking-tight">
              {translate("palmtree.dashboard.attention")}
            </h2>
            {rows.length === 0 ? (
              <p className="px-6 pb-6 text-[12.5px] text-muted-foreground">
                {translate("palmtree.dashboard.empty")}
              </p>
            ) : (
              <ul className="flex flex-col gap-3 px-6 pb-6">
                {rows.map(({ task, contact, latestNote }) => (
                  <ActionTile
                    key={task.id}
                    contact={contact}
                    className="flex items-start justify-between gap-4"
                  >
                    <div className="min-w-0">
                      <ActionTileName contact={contact} />
                      <p className="mt-1 text-[12.5px] text-muted-foreground">
                        {task.text}
                        {latestNote?.text
                          ? translate("palmtree.dashboard.note_suffix", {
                              text: latestNote.text,
                            })
                          : null}
                      </p>
                    </div>
                    <OpenTaskDue dueDate={task.due_date} />
                  </ActionTile>
                ))}
              </ul>
            )}
          </section>

          <section className={`${panelClass} h-fit`}>
            <h2 className="font-heading px-6 py-6 text-xl font-extrabold tracking-tight">
              {translate("palmtree.dashboard.today")}
            </h2>
            {preview.length === 0 ? (
              <p className="px-6 pb-6 text-[12.5px] text-muted-foreground">
                {translate("palmtree.dashboard.today_empty")}
              </p>
            ) : (
              <ul className="divide-y divide-border px-6">
                {preview.map(({ task, contact }) => (
                  <li key={task.id} className="py-3 text-sm first:pt-0">
                    <ContactNameLink contact={contact} />
                    <span className="text-[12.5px] text-muted-foreground">
                      {" "}
                      — {task.text}
                    </span>
                  </li>
                ))}
              </ul>
            )}
            <Link
              to="/vandaag"
              className="block px-6 pb-6 pt-3 text-[13px] font-semibold text-link hover:underline"
            >
              {translate("palmtree.dashboard.all_today")}
            </Link>
          </section>

          <DashboardNews />
        </div>
      </QueryFallback>
    </div>
  );
};
